import { Link, useLocation } from 'react-router-dom';
import { SovcombankLogo, SettingsIcon, FilmIcon, UsersIcon, PhoneIcon, LogoutIcon } from './Icons.jsx';
import { useAuthStore } from '../store/authStore.js';

/**
 * @param {object} props
 * @param {(id: string, role?: string) => void} [props.onEnterRoom]
 */
export default function Header() {
  const logout = useAuthStore((s) => s.logout);
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { path: '/', label: 'Комнаты', icon: UsersIcon, exact: true },
    { path: '/recordings', label: 'Записи звонков', icon: FilmIcon },
    { path: '/settings', label: 'Настройки', icon: SettingsIcon },
  ];

  return (
    <header className="bg-white/95 backdrop-blur-md border-b border-slate-200/90 sticky top-0 z-40 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        {/* Brand Logo: Official Sovcombank */}
        <Link to="/" className="flex items-center gap-3.5 group">
          <div className="shrink-0 group-hover:scale-105 transition-transform duration-200">
            <SovcombankLogo size={36} />
          </div>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="text-base sm:text-lg font-black tracking-tight text-[#002882] group-hover:text-[#001f66] transition-colors font-sans">
                СОВКОМБАНК
              </span>
              <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#f0f4fc] text-[#002882] border border-[#d1dcf0]">
                Видеосвязь
              </span>
            </div>
            <span className="hidden sm:block text-[11px] text-slate-500 font-medium -mt-0.5">
              Дистанционное обслуживание клиентов
            </span>
          </div>
        </Link>

        {/* Navigation Tabs */}
        <nav className="flex items-center gap-1.5 sm:gap-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = item.exact
              ? (currentPath === '/' || currentPath === '/rooms')
              : currentPath.startsWith(item.path);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all ${
                  isActive
                    ? 'bg-[#f0f4fc] text-[#002882] shadow-sm border border-[#d1dcf0]'
                    : 'text-slate-600 hover:text-[#002882] hover:bg-slate-100/80'
                }`}
              >
                <Icon size={16} className={isActive ? 'text-[#002882]' : 'text-slate-400'} />
                <span className="hidden sm:inline">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Support Hotline / Info & Logout */}
        <div className="flex items-center gap-3">
          <div className="hidden lg:flex items-center gap-2.5 text-right pl-4 border-l border-slate-200">
            <div className="w-8 h-8 rounded-full bg-[#f0f4fc] text-[#002882] flex items-center justify-center">
              <PhoneIcon size={15} />
            </div>
            <div>
              <a
                href="tel:88001000006"
                className="text-xs font-bold text-[#002882] hover:text-[#001f66] tracking-wide block"
              >
                8 800 100 00 06
              </a>
              <span className="text-[10px] text-slate-400 block -mt-0.5">
                Бесплатно по России
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={logout}
            title="Выйти из системы"
            className="p-2 sm:px-3 sm:py-1.5 rounded-xl bg-slate-100 hover:bg-red-50 text-slate-600 hover:text-red-600 border border-slate-200 text-xs font-semibold flex items-center gap-1.5 transition-all active:scale-95"
          >
            <LogoutIcon size={15} />
            <span className="hidden sm:inline">Выйти</span>
          </button>
        </div>
      </div>
    </header>
  );
}